import React from 'react';
import { EditorStringModel } from '../../Types/EditorString';

const EditorString = ({ value }: EditorStringModel) => {
  return value ? (
    <div
      className="editor-string"
      dangerouslySetInnerHTML={{ __html: value }}
    ></div>
  ) : null;
};

export default EditorString;
